// Lista cerrada de 40 idiomas (código ISO 639-1 + nombre)
export const LANGUAGES_40 = [
  { code: 'en', name: 'Inglés' },
  { code: 'zh', name: 'Chino (Mandarín)' },
  { code: 'es', name: 'Español' },
  { code: 'ar', name: 'Árabe' },
  { code: 'id', name: 'Indonesio / Malayo' },
  { code: 'pt', name: 'Portugués' },
  { code: 'fr', name: 'Francés' },
  { code: 'ja', name: 'Japonés' },
  { code: 'ru', name: 'Ruso' },
  { code: 'de', name: 'Alemán' },
  { code: 'nl', name: 'Holandés' },
  { code: 'pl', name: 'Polaco' },
  { code: 'tr', name: 'Turco' },
  { code: 'fa', name: 'Persa' },
  { code: 'vi', name: 'Vietnamita' },
  { code: 'cs', name: 'Checo' },
  { code: 'ko', name: 'Coreano' },
  { code: 'uk', name: 'Ucraniano' },
  { code: 'hu', name: 'Húngaro' },
  { code: 'sv', name: 'Sueco' },
  { code: 'ro', name: 'Rumano' },
  { code: 'el', name: 'Griego' },
  { code: 'he', name: 'Hebreo' },
  { code: 'da', name: 'Danés' },
  { code: 'fi', name: 'Finés' },
  { code: 'sk', name: 'Eslovaco' },
  { code: 'th', name: 'Tailandés' },
  { code: 'bg', name: 'Búlgaro' },
  { code: 'sr', name: 'Serbio' },
  { code: 'hr', name: 'Croata' },
  { code: 'lt', name: 'Lituano' },
  { code: 'nb', name: 'Noruego Bokmål' },
  { code: 'sl', name: 'Esloveno' },
  { code: 'ca', name: 'Catalán' },
  { code: 'et', name: 'Estonio' },
  { code: 'no', name: 'Noruego' },
  { code: 'lv', name: 'Letón' },
  { code: 'hi', name: 'Hindi' },
  { code: 'gd', name: 'Escocés (Gaélico)' },
  { code: 'ga', name: 'Irlandés' },
];

// Zonas horarias: usar Intl.supportedValuesOf si está disponible, si no, fallback a una lista breve y el default
export function getTimezones() {
  const fallback = [
    'America/Bogota',
    'America/Mexico_City',
    'America/New_York',
    'Europe/Madrid',
    'Europe/London',
    'Asia/Tokyo',
  ];
  try {
    const fn = Intl?.supportedValuesOf;
    if (typeof fn === 'function') {
      const tz = fn('timeZone');
      return Array.isArray(tz) && tz.length ? tz : fallback;
    }
  } catch (_) {}
  return fallback;
}
